import { Menu, MenuItem } from "~/common/mui";
import { useRef, useState } from "react";
import { useLanguageSelector } from "~/features/navigation/components/LanguageSelector/LanguageSelector";
import { Chip } from "~/common/mui/Chip/Chip";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { MENU_POS_LEFT } from "~/common/components/Menu/MenuPositions";

export const LanguageSelector = () => {
  const { currentLanguage, loading, languages, onItemClick } = useLanguageSelector();
  const [open, setOpen] = useState(false);
  const chipRef = useRef<HTMLDivElement | null>(null);

  if (languages.length <= 1) {
    return null;
  }

  const handleClick = (language: string) => {
    onItemClick(language);
  };

  const toggleMenu = () => {
    setOpen((prev) => !prev);
  };

  return (
    <>
      <Chip
        variant="assist"
        disabled={loading}
        label={currentLanguage.label}
        deleteIcon={<ArrowDropDownIcon sx={{ transform: open ? "rotate(180deg)" : "" }} />}
        onDelete={toggleMenu}
        onClick={toggleMenu}
        ref={chipRef}
      />
      <Menu
        open={open}
        onClose={() => setOpen(false)}
        anchorEl={chipRef.current}
        {...MENU_POS_LEFT}
        slotProps={{ paper: { sx: { width: "200px" } } }}
      >
        {languages.map(({ label, value }) => (
          <MenuItem key={value} onClick={() => handleClick(value)} selected={value === currentLanguage.value}>
            {label} {`(${value.toUpperCase()})`}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
